// extracted by mini-css-extract-plugin
module.exports = {"loader":"router_loader__3QTdW"};